import { api } from "../api";

export const updatePassword = async (patientId: string, password: string): Promise<string> => {
  await api.services.patient.setPatientPassword(patientId, { password });
  return password;
};
